import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';

interface SettingsTransactionMappingFilterPillSignature {
  Args: {
    label?: string;
    onRemove: () => void;
    value: string;
  };
}

const SettingsTransactionMappingFilterPill = <template>
  <div
    class="filter-pill rounded-100 bg-ghost-selected inline-flex h-fit items-center justify-between gap-100 px-200 py-100"
    data-test-id="filter-pill"
  >
    <div class="filter-pill__content flex flex-col">
      {{#if @label}}
        <span
          class="text-200--regular"
          data-test-id="filter-pill-label"
        >{{@label}}</span>
      {{/if}}

      <span
        class="text-200--bold truncate"
        data-test-id="filter-pill-value"
      >{{@value}}</span>
    </div>

    <PrismButton
      @buttonType="ghost"
      @icon="cross"
      @onClick={{@onRemove}}
      @size="small"
    />

    <PrismTooltip @delay={{25}} @text={{@value}} />
  </div>
</template> satisfies TOC<SettingsTransactionMappingFilterPillSignature>;

export default SettingsTransactionMappingFilterPill;
